import { useMemo } from "react";
import styles from "./AbilityDescriptionRenderer.module.css";

type AbilityDescriptionRendererProps = {
  description?: string;
};

export function AbilityDescriptionRenderer({ description }: ItemDescriptionRendererProps) {
  const __html = useMemo(() => {
    if (!description) return "";

    let r = description.replace("\n", "</br></br>");
    r = r.replace(/\[(.+?)\](.+?)\[\/\1\]/g, `<span data-keyword="$1">$2</span>`);

    return r;
  }, [description]);

  return (
    <div className={styles.itemDescriptionRendererRoot} dangerouslySetInnerHTML={{ __html }}></div>
  );
}
